import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { PopUpService, ModalComponent } from '../../core';
import { Question } from '../question';
import { QuestionsService } from '../questions.service';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'lms-question-detail',
  templateUrl: './question-detail.component.html',
  styleUrls: ['./question-detail.component.scss']
})
export class QuestionDetailComponent implements OnInit {
  public question: Question;
  public modal: ModalComponent;

  public filters: Map<string, string>;

  public questionsSortingFields = [
    { field: 'name', label: 'questions.sortableFields.name' },
    { field: 'email', label: 'questions.sortableFields.email' }
  ];

  constructor(
    public questionsService: QuestionsService,
    public route: ActivatedRoute,
    public location: Location,
    public router: Router,
    public translate: TranslateService,
    public popupService: PopUpService
  ) {}

  ngOnInit() {
    this.route.paramMap
      .pipe(switchMap((params: ParamMap) => this.questionsService.getQuestion(params.get('id'))))
      .subscribe((question) => {
        this.filters = new Map<string, string>().set('questionId', question.id);
        this.question = question;
      });
  }

  goBack(): void {
    this.location.back();
  }

  onUpdateQuestion(question: Question) {
    this.question = question;
    this.router.navigate(['/documents', question.documentId], { replaceUrl: true });
  }

  deleteQuestion() {
    this.popupService
      .confirmDelete({
        title: this.translate.instant('customizations.documents.questions.confirmDelete'),
        text: this.translate.instant('customizations.documents.questions.deleteMessage')
      })
      .then(() => this.questionsService.delete(this.question.id))
      .then(() => this.goBack())
      .catch((err) => {
        if (err !== 'cancel') {
          this.popupService.showError({
            title: this.translate.instant('questions.deleteError'),
            text: err.serverMessage
          });
        }
      });
  }
}
